import { darken } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { getContrastColorFrom } from '../../../common/colors';
import { BodyRegularSemiBold } from '../../../fonts/typography/Typography';

interface GradientButtonProps {
  actionColor: string;
  children: React.ReactNode;
  disabled?: boolean;
  onClick: () => void;
  dataCy?: string;
  fullWidth?: boolean;
}

const GradientButton = (props: GradientButtonProps) => {
  const { actionColor, children, onClick, disabled, dataCy, fullWidth = true } = props;

  const darkerColor = darken(0.1, actionColor);
  const textColor = getContrastColorFrom(actionColor);
  return (
    <GradientStyles
      onClick={onClick}
      textColor={textColor}
      actionColor={actionColor}
      darkerColor={darkerColor}
      disabled={disabled}
      data-cy={dataCy}
      $fullWidth={fullWidth}
    >
      {children}
    </GradientStyles>
  );
};

interface GradientStylesProps {
  actionColor: string;
  darkerColor: string;
  textColor: string;
  disabled?: boolean;
  $fullWidth?: boolean;
}

const GradientStyles = styled.button<GradientStylesProps>`
  ${BodyRegularSemiBold}
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, ${(props) => props.actionColor} 0%, ${(props) => props.darkerColor} 100%);
  justify-content: center;
  width: ${({ $fullWidth = true }) => ($fullWidth ? '100%' : 'auto')};
  border-radius: 5px;
  border: 1px solid ${(props) => props.darkerColor};
  padding: 8px;
  color: ${(props) => props.textColor};
  transition: box-shadow 0.1s ease-in;
  box-shadow: 0px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  &:hover {
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  }
  ${(props) => props.disabled && Disabled}

  svg {
    color: ${(props) => props.textColor};
    margin-left: 0.25rem;
    flex-shrink: 0;
  }
`;
const Disabled = css`
  background: #cecece;
  border: 1px solid transparent;
  cursor: not-allowed;
  &:hover {
    box-shadow: none;
  }
`;

export default GradientButton;
